<ng-template #popTemplate>  
    <div class="tooltip-content desktop" (click)="tooltip.hide()" (mouseenter)="cancelHide()" (mouseleave)="hide()">
      <div class="tooltip-title" *ngIf="title">
        {{ title | translate }}
      </div>
      <div class="tooltip-description">
        {{ tooltipCopy | translate }}
        <span class="tooltip-link display-inline" *ngIf="link">
          <a href="{{ link }}" (click)="tooltip.hide()" class="card-icon-lists" target="_blank">{{ linkTitle | translate }}
        </a>
        </span>
      </div>      
    </div>
    <div class="tooltip-content mobile">
      <div class="tooltip-title" *ngIf="title">
        {{ title | translate }}
      </div>
      <div class="tooltip-description">
        {{ tooltipCopy | translate }}
        <span class="tooltip-link display-inline" *ngIf="link">
          <a href="{{ link }}" (click)="tooltip.hide()" class="card-icon-lists" target="_blank">{{ linkTitle | translate }}
        </a>
        </span>
      </div>      
      <div class="tooltip-close" *ngIf="hasCloseButton">
        <span (click)="tooltip.hide()">
            Close
        </span>
      </div>
    </div>  
</ng-template>
<ng-template #popTemplateForNoImage>
  <div class="img-tooltip-content" [class.bank-number-tooltip-content]="title === 'ROUTING NUMBER' || title === 'ACCOUNT NUMBER'" [class.desktop-right-tooltip]="desktopPlacementLocation === 'right'" (click)="tooltip.hide()" (mouseenter)="cancelHide()" (mouseleave)="hide()">
    <div class="img-tooltip-title" *ngIf="title">
      You can find your <span class="font-weight-500 fs-16">{{ title | translate }}</span> here:
    </div>
    <div class="img-tooltip-title" *ngIf="fullTitle?.length">
      <span>{{ fullTitle | translate }}</span>
    </div>
    <div class="img-tooltip-desc" *ngIf="description?.length">
      <span>{{ description | translate }}</span>
    </div> 
    <img [src]="imgPath"/>
  </div>  
</ng-template>
<ng-container *ngIf="imageHasBody; else noImageTooltip">
  <span  class="waves-light tooltip-button {{project}} {{additionalClasses}}" [mdbPopover]="popTemplateForNoImage" [placement]="responsivePlacementLocation"
  [trigger]="trigger" #tooltip="mdbPopover" [animation]="false" (mouseenter)="show()" (mouseleave)="hide()"
      (popoverShow)="onTooltipShow()" (popoverHide)="onTooltipHide()" mdbRipple>
      <ng-container *ngIf="isAcmic; else maTooltipIcon">
        <img src="assets/img/images/icon-info-acmic.svg" class="img-body-tooltip-icon"/>
      </ng-container>
      <ng-template #maTooltipIcon>        
        <img src="assets/img/images/icon-info.svg" class="img-body-tooltip-icon"/>
      </ng-template>
  </span>
</ng-container>
<ng-template #noImageTooltip>
  <span mdbRipple class="waves-light tooltip-button {{project}} {{additionalClasses}}" [animation]="false" [mdbTooltip]="popTemplate" [placement]="responsivePlacementLocation" 
  [trigger]="trigger" #tooltip="mdbTooltip" (mouseover)="show()"
     (tooltipShow)="onTooltipShow()" (tooltipHide)="onTooltipHide()">
      <ng-content></ng-content>
  </span>
</ng-template>
